module.exports = __webpack_public_path__ + "static/media/the_fight_for_food_security_desktop.e52bbc39.jpg";